// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2vw5b","productName":"Table_productName__3Br5T"};